import { STATUS } from '../../lib/constants';

export default function StatusBadge({ status, showIcon = true }) {
    const statusInfo = STATUS[status] || STATUS.chegando;

    return (
        <span
            className={`status-badge ${statusInfo.bgClass} ${statusInfo.textClass} ${statusInfo.borderClass} border`}
        >
            {showIcon && <span>{statusInfo.icon}</span>}
            <span>{statusInfo.label}</span>
        </span>
    );
}
